"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styles_1 = require("@material-ui/core/styles");

var useStyles = (0, styles_1.makeStyles)(function (theme) {
  return {
    root: {
      padding: theme.spacing(3),
      paddingBottom: '40vh',
      paddingTop: theme.spacing(4),
      '& .story-timeline__element .vertical-timeline-element-content': {
        padding: 0,
        '&:after': {
          content: 'unset'
        }
      }
    }
  };
});
exports.default = useStyles;